import DOMPurify from 'dompurify';

type Options = {
  title?: string;
};

export const printContent = (elementRef: HTMLElement, options: Options = {}) => {
  if (!elementRef) return;

  const sanitizedTitle = options?.title ? DOMPurify.sanitize(options.title) : '';
  const sanitizedContent = DOMPurify.sanitize(elementRef.innerHTML);

  const newWindow = window.open('', '_blank') as Window;

  newWindow.document.write(
    `<html><head><title>${sanitizedTitle}</title></head><body style="margin: 0px;">${sanitizedContent}</body></html>`,
  );

  newWindow.print();
  newWindow.close();
};
